import React from 'react';
import PropTypes from 'prop-types';
import memoize from 'lodash/memoize';
import { fetchImgAsBase64 } from '@Utils/Network';

import Button from '@Components/Button';
import ImageBase64 from '@Components/ImageBase64';
import StructureFilterSelectedOptionTitles from './StructureFilterSelectedOptionTitles';

const memorizedFetchImgAsBase64 = memoize(fetchImgAsBase64);


export default function StructureFilterPreview(props) {
  const {
    drawing,
    clearDrawn,
    drawOnClick,
  } = props;
  const { preview } = drawing;

  return (
    <>
      <div className='structure-filter-preview-wrapper'>
        <Button
          onClick={clearDrawn}
          buttonConfig={{
            type: 'link',
            size: 'sm',
            className: 'structure-filter-close-wrapper',
            e2eName: 'delete-structure',
            ariaLabel: 'Delete structure',
          }}
          iconConfig={{ name: 'delete', size: 'tiny' }}
        />

        <ImageBase64
          src={preview}
          getImageAsync={memorizedFetchImgAsBase64}
        >
          {
            ({ src }) => {
              if (!src) {
                return null;
              }

              return (
                <img
                  alt='Structure Preview'
                  src={src}
                  className='structure-filter-preview'
                />
              );
            }
          }
        </ImageBase64>

        <Button
          onClick={drawOnClick}
          buttonConfig={{
            type: 'link',
            size: 'lg',
            className: 'structure-filter-edit-wrapper',
            e2eName: 'edit-structure',
            ariaLabel: 'Edit structure',
          }}
          iconConfig={{ name: 'pencil', size: 'lg' }}
        />
      </div>
      <StructureFilterSelectedOptionTitles {...props} />
    </>
  );
}

StructureFilterPreview.propTypes = {
  drawing: PropTypes.shape({
    preview: PropTypes.string.isRequired,
  }),
  clearDrawn: PropTypes.func.isRequired,
  drawOnClick: PropTypes.func.isRequired,
  optionsButtonOnClick: PropTypes.func.isRequired,
};
